import { Component, Vue, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import * as T_T from 'cryface';
import { PhoneNumberFormat, PhoneNumberUtil, PhoneNumber } from 'google-libphonenumber';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import Internationalizer from '../Internationalizer/internationalizer.vue';

@Component({
   components: {
      Internationalizer
   }
})
export default class Header extends Vue {
   public title: string = 'Header';

   public userInfoService = new UserInfoDelegate();

   public configs = new CommonConfig();

   public agentName = '';

   public phone = '';

   public avatarUri = '';

   public burgerMenuVisible = false;

   public homeSelected = true;

   public propertySelected = false;

   public blogSelected = false;

   public dailyReportSelected = false;

   @Watch('$store.state.navBar', { immediate: true, deep: true })
   public onSectionChanged(val: any, oldVal: any) {
      this.burgerMenuVisible = val.burgerMenuVisible;
   }

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public onUserChanged(val: any, oldVal: any) {
      this.avatarUri = T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : '';
      this.agentName = val.value.agentName;
      const phone = T_T.simpleDetect(val.value.agentMobile) ? val.value.agentMobile : val.value.agentPhone;

      if (phone) {
         const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
         const phoneNumber: PhoneNumber = phoneUtil.parseAndKeepRawInput(phone);
         this.phone = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
      }
   }

   public handleBurgerOpen() {
      this.$store.commit('invokeHeaderBurger');
   }

   public handleBurgerClose() {
      this.$store.commit('sleepHeaderBurger');
   }

   public nav(route: string) {
      // this.$router.push(route);
      // this.$store.commit('navTo', route);
      // const userName = this.userInfoService.Data;
      // switch (route) {
      //    case `/home`: this.homeSelected = true; this.propertySelected = false; this.blogSelected = false; break;
      //    case `/listings`: this.homeSelected = false; this.propertySelected = true; this.blogSelected = false; break;
      //    case `/blogs`: this.homeSelected = false; this.propertySelected = false; this.blogSelected = true; break;
      // }
   }

   public onAvatarClick() {
      this.$router.push('/');
   }

   public async created() {
   }
}
